import React from 'react';
import Sidebar from '../Sidebar';
import FeedbackForm from "../feedback/FeedbackList";

function FeedbackRoute() {

  return (
    <div className="app">
      <Sidebar />
      <div className="main-content scroll">
        <FeedbackForm />
      </div>
    </div>
  );
}

export default FeedbackRoute;
